﻿import { showNotification } from "../../utilities/notification";

export class Preferences
{
    private readonly form: HTMLFormElement;
    private readonly saveButton: HTMLButtonElement | null;

    constructor(form: HTMLFormElement)
    {
        this.form = form;
        this.saveButton = this.form.querySelector<HTMLButtonElement>(".js-save-preferences");

        this.attachEvents();
    }

    private attachEvents(): void
    {
        this.saveButton?.addEventListener("click", (event: MouseEvent): void =>
        {
            event.preventDefault();
            this.save();
        });
    }

    private save(): void
    {
        if (!this.saveButton)
        {
            return;
        }

        const $form = $(this.form);
        const action = this.form.action || window.location.href;

        this.saveButton.disabled = true;

        $.ajax({
            type: "POST",
            url: action,
            data: $form.serialize(),
            dataType: "html",
            success: (): void =>
            {
                showNotification({
                    title: "Voorkeuren opgeslagen",
                    message: "Je voorkeuren zijn succesvol opgeslagen.",
                    status: "success"
                });
            },
            error: (): void =>
            {
                showNotification({
                    title: "Opslaan mislukt",
                    message: "Je voorkeuren konden niet worden opgeslagen.",
                    status: "danger"
                });
            },
            complete: (): void =>
            {
                this.saveButton!.disabled = false;
            }
        });
    }
}

export const reInitPreferences = (): void =>
{
    document
        .querySelectorAll<HTMLFormElement>(".js-preferences-form")
        .forEach((form): void =>
        {
            if (form.dataset.preferencesInitialized === "true")
            {
                return;
            }

            new Preferences(form);

            form.dataset.preferencesInitialized = "true";
        });
};

if (document.readyState === "loading")
{
    document.addEventListener(
        "DOMContentLoaded",
        reInitPreferences
    );
}
else
{
    reInitPreferences();
}

(window as any).Preferences = Preferences;